import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { AutoBookHistory } from "@app/models/rest/auto-book-history";

@Injectable({
  providedIn: "root"
})
export class AutoBookHistoryRestService extends HateoasResourceOperation<AutoBookHistory> {
  constructor() {
    super(AutoBookHistory);
  }
}
